import { PropsWithChildren } from "react";

import { makeStyles } from "@material-ui/core";

export const sidebarBreakpoint = 950;
export const sidebarWidth = 280;

const useStyles = makeStyles(theme => ({
    root: {
        width: `${sidebarWidth}px`,
        flexShrink: 0,

        [theme.breakpoints.down(sidebarBreakpoint)]: {
            display: "none",
        },
    },
    sidebar: {
        position: "fixed",
        width: "inherit",
        top: 0,
        left: 0,
        bottom: 0,

        backgroundColor: "#EBF3EA",
        boxShadow: theme.shadows[1],
        overflow: "scroll",
    },
    separator: theme.mixins.toolbar,
}));

export const Sidebar = (props: PropsWithChildren<{}>) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.sidebar}>
                <div className={classes.separator} />

                {props.children}

            </div>
        </div>
    );
};
